import React from 'react';

import { FilePickerProps } from '../../FilePicker';
import Aura from '../../../_common/Aura/Aura';
import Outline from '../../../_common/Outline/Outline';
import CoreFilePicker from '../CoreFilePicker/CoreFilePicker';

import { FilePickerTableWrapper } from '../../styles';

const TableFilePicker = (props: FilePickerProps) => {
  const { className, style, 'data-testid': dataTestId, ...otherProps } = props;
  return (
    <>
      <FilePickerTableWrapper data-testid={dataTestId}>
        <CoreFilePicker {...otherProps} isCell />
      </FilePickerTableWrapper>
      <Aura theme={{ disabled: props.disabled }} htmlFor={props.id} />
      <Outline theme={{ invalid: props.isInvalid, disabled: props.disabled }} inputComponent={FilePickerTableWrapper} />
    </>
  );
};

TableFilePicker.defaultProps = {
  name: null,
  multiple: false,
  onFocus: () => {},
  onChange: () => {},
  onBlur: () => {},
  onDelete: () => {},
  accept: undefined,
  size: undefined,
  isCell: false,
  disabled: false,
  isInvalid: false,
  autoFocus: false,
  customError: undefined,
  'data-testid': undefined,
};

export default TableFilePicker;
